import { render, staticRenderFns } from "./photoDevice.bak.vue?vue&type=template&id=5ede6ea0&scoped=true"
import script from "./photoDevice.bak.vue?vue&type=script&lang=js"
export * from "./photoDevice.bak.vue?vue&type=script&lang=js"
import style0 from "./photoDevice.bak.vue?vue&type=style&index=0&id=5ede6ea0&prod&lang=less&scoped=true"
import style1 from "./photoDevice.bak.vue?vue&type=style&index=1&id=5ede6ea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede6ea0",
  null
  
)

export default component.exports